/* Grondyke · founder click-to-play. The poster is the composed frame; the film only loads when
   asked for. [data-gk-founder][data-gk-video] wraps the poster; on click it is replaced by <video>. */
(function () {
  if (window.GKHomeFounder) return;
  window.GKHomeFounder = true;
  function bind(el) {
    if (el.dataset.gkReady) return;
    el.dataset.gkReady = '1';
    var src = el.getAttribute('data-gk-video');
    if (!src) return;
    el.addEventListener('click', function () {
      var v = document.createElement('video');
      v.src = src;
      v.setAttribute('controls', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('autoplay', '');
      v.className = 'gk-founder__video';
      el.replaceWith(v);
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }
  function init(root) {
    var els = (root || document).querySelectorAll('[data-gk-founder]');
    for (var i = 0; i < els.length; i++) bind(els[i]);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(); }); } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
